export default "__VITE_ASSET__C6_GoxT8__"